import { Button } from '@/components/Common';
import { Modal } from '..';
import { AlertModalProps } from './AlertModal.types';

export const AlertModal = ({
  isOpen,
  onClose,
  title,
  message,
  buttonTitle,
  buttonCancelTitle,
  handleConfirm,
}: AlertModalProps) => {
  return (
    <Modal

      isOpen={isOpen}
      onClose={onClose}
      headerStyle="bg-[#2A2A2A] !h-[50px]"
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem] max-w-[700px]"
    >
      <div className="p-6">
        <h2 className="text-white text-xl text-center mb-4">{title}</h2>
        <p className="text-[#ADADB1] text-center mb-6">{message}</p>
        <div className="flex justify-center gap-4">
          <Button
            title={buttonCancelTitle}
            className="w-[120px] !bg-[#BD292F] text-white"
            onClick={onClose}
          />
          <Button
            title={buttonTitle}

            className="w-[120px]"
            type="submit"
            onClick={handleConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};
